/* Inkfold software changelog — auto-expand the first <details> */
(function () {
  const changelog = document.querySelector("[data-vs-changelog]");
  if (!changelog) return;
  const firstDetails = changelog.querySelector("details");
  if (firstDetails) firstDetails.setAttribute("open", "");
})();
